import { useSEO } from "../components/SEO";
import FadeIn from "../components/FadeIn";
import TestFinder from "../components/TestFinder";
import FinalCTA from "../components/FinalCTA";

const TestsPage = () => {
  useSEO(
    "Diagnostic Tests in Bhopal | Dr Lal PathLabs Collection Center",
    "Search and enquire about diagnostic tests in Bhopal — blood tests, diabetes, thyroid, liver, kidney, lipid profile, vitamins and more. Call 8959830932."
  );

  return (
    <div>
      <section className="bg-[#0B3056] py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <FadeIn>
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-blue-200">Diagnostic Tests</p>
            <h1 className="font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
              What Test Are You Looking For?
            </h1>
            <p className="mt-4 max-w-2xl text-base text-blue-100 md:text-lg">
              Search common diagnostic tests available for enquiry at our Bhopal collection center. Many more
              investigations are available — contact us for availability and current prices.
            </p>
          </FadeIn>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <TestFinder />
        <FadeIn className="mt-10 rounded-2xl bg-[#F0F7FA] p-6">
          <p className="text-sm leading-relaxed text-slate-600">
            Note: This list covers commonly enquired investigations. Test availability may vary, and prices are shared
            by the collection center on enquiry. This website does not provide medical interpretation of test results —
            please consult a qualified healthcare professional.
          </p>
        </FadeIn>
      </section>

      <FinalCTA />
    </div>
  );
};

export default TestsPage;
